<script>
  import { onMount } from "svelte";
  import { settingStores } from "@stores/settingStores.js";

  import { TextInput, Select } from "paxray-components-svelte";
  import SearchInput from "./components/SearchInput.svelte";
  import Modal from "../../../lib/components/Modal.svelte";
  import MultiSelect from "../../../lib/components/MultiSelect.svelte";
  import CustomTable from "../../../lib/components/CustomTable/index.svelte";

  import Header from "../../../lib/components/Header.svelte";
  import { SectionWrapper } from "paxray-components-svelte";
  import Button from "../../../lib/components/Button.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  export let embedded = false;

  let users = [];

  let deleteElementModal = false;
  let moveElementModal = false;
  let createElemetModal = false;
  let newElementName = "";
  let deleteElementObj = "";
  let searchedItems = undefined;
  let inputTeams = [];
  let inputUsers = [];
  let deleteTeamInput = "";
  let elementTypeValue = "Folder";
  let children = [];
  let newParentId = null;
  let filteredTeams = [];
  let filteredUsers = [];
  let selectedMoveableFolder = "";
  let sortedFolderList = [{ value: "selectFolder", text: "Folder" }];
  let payloadAccessRights = {
    add_team: [],
    remove_team: [],
    add_user: [],
    remove_user: [],
  };
  $: ({ teams, users } = $settingStores);
  $: sortedDataObject = [...(teams || []), ...(users || [])].reduce(
    (acc, d) => {
      if (d?.id == null) return acc;
      acc[d.id] = d?.text ?? d?.name ?? d?.username ?? "";
      return acc;
    },
    {},
  );

  $: deleteElementValidation = deleteTeamInput !== deleteElementObj.name;
  $: allFolderList = [];
  $: getFolderList = (data, target) => {
    const obj = data.map((d) => {
      if (d.type === "folder") {
        if (!target) {
          allFolderList = [
            ...allFolderList,
            {
              value: JSON.stringify(d),
              text: d.name,
              access_right: d.access_right,
            },
          ];
        } else if (
          d.id !== target?.id &&
          d.id !== target?.parentid &&
          d.id !== target?.folderid
        ) {
          sortedFolderList = [
            ...sortedFolderList,
            {
              value: JSON.stringify(d),
              text: d.name,
              access_right: d.access_right,
            },
          ];
        }
      }
      if (d.children.length && d.id !== target?.id)
        getFolderList(d.children, target);
      return { id: d.id, name: d.name };
    });
    return obj;
  };

  const { getTeams } = settingStores;

  const onRemove = (row, cell) => {
    deleteElementObj = row;
    deleteElementModal = true;
  };

  const getCapitalizeText = (value, flag) => {
    if (createElemetModal?.key === "newElement" || flag) {
      const text = value || "";
      const result = text.replace(/([A-Z])/g, " $1");
      return result.charAt(0).toUpperCase() + result.slice(1);
    } else {
      return "";
    }
  };

  const onSearch = (value) => {
    if (children && value.detail) {
      const searchTerm = value.detail.toLowerCase();
      const filteredItems = children.filter((child) => {
        return child.name && child.name.toLowerCase().includes(searchTerm);
      });
      searchedItems = filteredItems;
    } else {
      searchedItems = undefined;
    }
  };

  const confirmDeleteElemet = () => {
    if (deleteElementValidation) return;
    deleteElementModal = false;
    fetchWithSession(
      `/api/pman/${
        deleteElementObj.type === "process"
          ? "deleteProcessModel"
          : "deleteProcessFolder"
      }`,
      {
        method: "POST",
        body: JSON.stringify({
          id: deleteElementObj.id,
        }),
      },
    )
      .then((response) => response.json())
      .then((res) => {
        fetchProcessFolders();
      });
  };

  const handleMoveElement = () => {
    if (moveElementModal?.type === "folder") {
      handleUpdateFolder(true);
    } else {
      handleCreateProcess(true, true);
    }
    moveElementModal = false;
  };

  const getIntersectedAccessRights = (accessA, accessB) => {
    let add_user,
      add_team,
      remove_user,
      remove_team = [];
    remove_team = accessA.team_ids.filter((d) => !accessB.team_ids.includes(d));
    remove_user = accessA.user_ids.filter((d) => !accessB.user_ids.includes(d));
    return {
      remove_team,
      remove_user,
      add_user,
      add_team,
    };
  };

  const handleTypeChange = (event) => {
    elementTypeValue = event.target.value;
  };

  const newTeamChanges = (event) => {
    const newTeams = event.detail.selected.map((d) => d.id);
    const previousTeams = createElemetModal?.access_right?.team_ids || [];
    payloadAccessRights.add_team = newTeams.filter(
      (d) => !previousTeams.includes(d),
    );
    payloadAccessRights.remove_team = previousTeams.filter(
      (d) => !newTeams.includes(d),
    );
    inputTeams = event.detail.selected.map((d) => d.id);
  };

  const newFolderChange = (event) => {
    if (event.target.value === "selectFolder") return;
    const selectedValue = JSON.parse(event.target.value);
    const data = getIntersectedAccessRights(
      moveElementModal?.access_right,
      selectedValue?.access_right,
    );
    payloadAccessRights.remove_team = data.remove_team;
    payloadAccessRights.remove_user = data.remove_user;
    selectedMoveableFolder = selectedValue?.id || "";
  };

  const newUserChanges = (event) => {
    const newUsers = event.detail.selected.map((d) => d.id);
    const previousUsers = createElemetModal?.access_right?.user_ids || [];
    payloadAccessRights.add_user = newUsers.filter(
      (d) => !previousUsers.includes(d),
    );
    payloadAccessRights.remove_user = previousUsers.filter(
      (d) => !newUsers.includes(d),
    );
    inputUsers = event.detail.selected.map((d) => d.id);
  };

  const handleCreateNewFolder = () => {
    fetchWithSession(`/api/pman/addProcessFolder`, {
      method: "POST",
      body: JSON.stringify({
        name: newElementName,
        parentid: newParentId,
        add_team: inputTeams,
        add_user: inputUsers,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status == "success") {
          fetchProcessFolders();
        }
      });
  };

  const handleCreateProcess = (update, move) => {
    const payload = {
      name: newElementName,
      [update ? "id" : "folderid"]: newParentId,
      add_team: update ? payloadAccessRights.add_team : inputTeams,
      add_user: update ? payloadAccessRights.add_user : inputUsers,
      remove_team: update ? payloadAccessRights.remove_team : [],
      remove_user: update ? payloadAccessRights.remove_user : [],
    };
    if (move) {
      payload.folderid = selectedMoveableFolder;
    }
    fetchWithSession(`/api/pman/saveProcessModel`, {
      method: "POST",
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status == "success") {
          fetchProcessFolders();
        }
      });
  };

  const handleUpdateFolder = (move) => {
    const payload = {
      name: newElementName,
      id: newParentId,
      ...payloadAccessRights,
    };
    if (move) {
      payload.parentid = selectedMoveableFolder;
    }
    fetchWithSession(`/api/pman/saveProcessFolder`, {
      method: "POST",
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status == "success") {
          fetchProcessFolders();
        }
      });
  };

  const handleModalPrimaryAction = () => {
    if (elementTypeValue === "process" && createElemetModal.key !== "edit") {
      handleCreateProcess();
    } else if (createElemetModal.key === "edit") {
      if (createElemetModal.type === "process") handleCreateProcess(true);
      else handleUpdateFolder();
    } else {
      handleCreateNewFolder();
    }
    createElemetModal = false;
  };

  function fetchProcessFolders() {
    allFolderList = [];
    fetchWithSession(`/api/pman/processFolders`)
      .then((response) => response.json())
      .then((data) => {
        children = data;
        getFolderList(data);
      });
  }

  const handleOpenMoveModal = (data, type, parentRow) => {
    newParentId = data.id;
    moveElementModal = data;
    getFolderList(children, data);
  };

  const handleOpenCreateEditModal = (data, type, parentRow) => {
    newParentId = data.id;
    let obj = data;
    if (type) {
      obj = {
        ...obj,
        title:
          type == "edit" ? `Edit ${data.type} ${data.name}` : "New Element",
        actionText: type !== "edit" ? "Create" : "Save",
        key: type,
      };
    }
    filteredTeams = teams;
    filteredUsers = users.map((d) => ({ id: d.id, text: d.username }));
    if (type === "edit") {
      newElementName = obj.name;
      if (Object.keys(parentRow).length) {
        filteredTeams = teams.filter((d) =>
          parentRow.access_right.team_ids.includes(d.id),
        );
        filteredUsers = users.filter((d) =>
          parentRow.access_right.user_ids.includes(d.id),
        );
      }
    } else if (type === "newElement") {
      filteredTeams = teams.filter((d) =>
        obj.access_right.team_ids.includes(d.id),
      );
      filteredUsers = users.filter((d) =>
        obj.access_right.user_ids.includes(d.id),
      );
    }
    createElemetModal = obj || true;
  };

  const handleCloseCreateEditModal = () => {
    sortedFolderList = [{ value: "selectFolder", text: "Folder" }];
    payloadAccessRights = {
      add_team: [],
      remove_team: [],
      add_user: [],
      remove_user: [],
    };
    elementTypeValue = "Folder";
    newParentId = null;
    newElementName = "";
  };

  onMount(() => {
    fetchProcessFolders();
    if (!teams || teams.length === 0 || !users || users.length === 0) {
      getTeams();
    }
  });

  let headers = [
    { key: "name", value: "Name" },
    { key: "access_right", value: "Access-Rights" },
    {
      key: "move",
      value: "Move",
      type: "action",
      icon: "move",
      action: handleOpenMoveModal,
    },
    {
      key: "actions",
      value: "Actions",
      type: "actions",
      actions: [
        { key: "newElement", icon: "add", action: handleOpenCreateEditModal },
        { key: "edit", icon: "edit", action: handleOpenCreateEditModal },
        { key: "delete", icon: "remove", action: onRemove },
      ],
    },
  ];
</script>

{#if !embedded}
  <Header
    section="Data Management"
    area="Settings"
    areaHref="/app/settings/"
    breadcrumb="Data Management"
  >
    <SearchInput on:search={onSearch} />
    <Button
      on:click={() =>
        handleOpenCreateEditModal({
          title: "New Folder",
          actionText: "Create Folder",
          placeholder: "Folder Name",
        })}
      variant="secondary"
      iconLeft={true}
      setting={true}
      text="Add Folder"
      icon="plus"
    />
  </Header>
{/if}

{#if !embedded}
  <SectionWrapper fullscreen shrinkContent>
    <section slot="main" class="data-content">
      <div class="table_summary">
        <div class="table_heading">
          <h5>Data Management</h5>
          <div>Manage access to platform processes and data folders.</div>
        </div>
      </div>
      <CustomTable
        dataObject={sortedDataObject}
        rows={searchedItems || children}
        {headers}
      />
    </section>
  </SectionWrapper>
{:else}
  <section class="data-content embedded-data-content">
    <div class="embedded-toolbar">
      <SearchInput on:search={onSearch} />
      <Button
        on:click={() =>
          handleOpenCreateEditModal({
            title: "New Folder",
            actionText: "Create Folder",
            placeholder: "Folder Name",
          })}
        variant="secondary"
        iconLeft={true}
        setting={true}
        text="Add Folder"
        icon="plus"
      />
    </div>
    <CustomTable
      dataObject={sortedDataObject}
      rows={searchedItems || children}
      {headers}
    />
  </section>
{/if}

<Modal
  preventCloseOnClickOutside
  actions
  size="lg"
  autowidth={true}
  bind:open={deleteElementModal}
  modalHeading={`Delete ${deleteElementObj.type} ${deleteElementObj?.name}`}
  primaryButtonText="Delete"
  primaryButtonAction={confirmDeleteElemet}
  width={653}
  bind:primaryButtonValidations={deleteElementValidation}
  on:close={() => {
    deleteTeamInput = "";
  }}
>
  <div class="deleteModalBody">
    Please enter the <span
      >{deleteElementObj.type} {deleteElementObj?.name}</span
    >
    to remove the {deleteElementObj.type}.
    <span>Caution! This cannot be undone.</span>
  </div>
  <TextInput
    placeholder="{deleteElementObj.type} Name"
    bind:value={deleteTeamInput}
  />
</Modal>

<Modal
  actions
  autowidth={true}
  preventCloseOnClickOutside
  size="lg"
  bind:open={moveElementModal}
  modalHeading={`Move ${moveElementModal?.type} ${moveElementModal?.name}`}
  primaryButtonText="Move Element"
  primaryButtonAction={handleMoveElement}
  width={653}
  on:close={handleCloseCreateEditModal}
>
  <Select
    selected={""}
    items={sortedFolderList}
    onchange={newFolderChange}
    labelText="Select New Folder(s)"
    label="Folder"
  />
</Modal>

<Modal
  size="sm"
  bind:open={createElemetModal}
  modalHeading={createElemetModal?.title || "Title"}
  actions
  preventCloseOnClickOutside
  autowidth={true}
  width={653}
  primaryButtonText={(createElemetModal?.actionText || "Save") +
    " " +
    getCapitalizeText(elementTypeValue)}
  primaryButtonAction={handleModalPrimaryAction}
  on:close={handleCloseCreateEditModal}
>
  <div>
    {#if createElemetModal?.key === "newElement"}
      <Select
        items={[
          { value: "folder", text: "Folder" },
          { value: "process", text: "Process" },
        ]}
        labelText="Type"
        onchange={handleTypeChange}
        selected={elementTypeValue}
      />
    {/if}
    <TextInput
      labelText="Name"
      placeholder={getCapitalizeText(elementTypeValue) +
        " " +
        (createElemetModal?.placeholder || "Name")}
      bind:value={newElementName}
    />
    {#if createElemetModal?.key === "edit"}
      <!-- <TextInput
          labelText="{getCapitalizeText(createElemetModal?.type, true)} Owner"
          placeholder="{getCapitalizeText(createElemetModal?.type, true)} Owner"
          bind:value={newElementName}
        /> -->
    {/if}
    <MultiSelect
      selectedIds={createElemetModal?.access_right?.team_ids || []}
      items={filteredTeams}
      onchange={newTeamChanges}
      labelText="Team(s)"
      label="Team"
    />
    <MultiSelect
      selectedIds={createElemetModal?.access_right?.user_ids || []}
      items={filteredUsers}
      onchange={newUserChanges}
      labelText="User(s)"
      label="User"
    />
  </div>
</Modal>

<style>
  section {
    width: 100%;
  }
  .embedded-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    margin-bottom: 1rem;
    gap: 0.75rem;
  }
  .embedded-toolbar :global(.search-input) {
    flex: 1;
    min-width: 0;
  }
  .embedded-toolbar :global(.search-input input) {
    flex: 1;
    min-width: 0;
    width: 100%;
  }
  .embedded-data-content {
    min-height: 0;
  }
  :global(.data-content .bx--data-table th:last-child),
  :global(.data-content .bx--data-table td:last-child) {
    width: 1%;
    white-space: nowrap;
    text-align: left;
  }
  :global(.data-content .bx--data-table th) {
    text-align: left;
  }
  :global(.data-content .actions-header),
  :global(.data-content .actions-column) {
    width: 1% !important;
    text-align: left !important;
  }
  :global(.data-content .actions-header .bx--table-header-label) {
    text-align: left !important;
  }
  :global(.data-content .bx--data-table td:last-child .actions-cell) {
    justify-content: flex-start;
  }
  .table_summary {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .table_heading {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    flex: 1;
    background-color: var(--pax-white);
    border: 1px solid var(--pax-black);
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
  }

  .table_heading h5 {
    margin: 0;
    color: var(--pax-black);
  }

  .table_heading div {
    color: #6f7681;
    font-size: 0.85rem;
    line-height: 1.1;
  }
  :global(.cross-plus-icon) {
    rotate: 45deg;
  }
  .deleteModalBody {
    padding: 23px 0px 23px 0px;
    font-family: Inter;
    font-size: 14px;
  }
  .deleteModalBody span {
    font-weight: 700;
  }
  .deleteModalBody :last-child {
    color: var(--pax-orange);
  }
</style>
